import { render, staticRenderFns } from "./StorageLocationDetailsView.vue?vue&type=template&id=42872a36&scoped=true&"
import script from "./StorageLocationDetailsView.vue?vue&type=script&lang=js&"
export * from "./StorageLocationDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42872a36",
  null
  
)

export default component.exports